<template>
  <v-container class="px-4 py-6">
    <h1 style="font-family: 'montserrat-bold';">Movimientos</h1>
    <v-row class="ma-0">
      <v-spacer></v-spacer>
      <v-col class="pa-0 mb-4" style="display: flex; justify-content: flex-end;">
        <v-autocomplete
          :label="'Selecciona una currency'"
          :items="currencies"
          hide-details
          style="font-family: 'montserrat-medium'; border-radius: 20px;"
          outlined
          class="mr-2"
          color="black"
          item-value="sValue"
          item-text="sName"
          @change="getMovements()"
          v-model="selectedCurrency"
        ></v-autocomplete>
      </v-col>
    </v-row>
    <div Style="display: flex; gap: 20px; justify-content: space-around; overflow-x: auto;">
      <v-card elevation="0">
        <v-card-title style="font-family: 'montserrat-bold';">
          Ingresos
          <v-col class="d-flex justify-end pa-0 my-4" style="align-items: center;">
            <v-btn color="black" elevation="8" class="white--text ml-4" style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none;" @click="dataXLSXIncomes()">
              <v-img class="mr-2" src="../../assets/icons/Vector.svg" style="width: 14px;"></v-img>
              {{ "Descargar" }}
            </v-btn>
          </v-col>
        </v-card-title>
        <v-data-table class="d-none d-sm-block mx-4" :items-per-page="5" hide-default-header :items="incomes" style="background-color: white !important">
          <template v-slot:header="{ props }">
            <thead style="background-color: #f9fafd;">
              <tr>
                <th class="header__title left">{{ "Id" }}</th>    
                <th class="header__title center">{{ "Monto" }}</th>                                                                                                                                                                               
                <th class="header__title right">{{ "Fecha" }}</th>
              </tr>
            </thead>
          </template>
          <template v-slot:body="{ items }">
            <tbody style="background: #f9fafd;">
              <tr v-for="item in items" :key="item.id">
                <td class="table__item">{{ item.iTrackingId}}</td>
                <td class="table__item">{{ "$ " + formatMoney(item.dAmount) + " " + (item.sCurrency ? item.sCurrency : "") }}</td>
                <td class="table__item">{{ formatDate(item.created_at) }}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
        <v-card-subtitle class="text-right mt-2 mr-4" style="font-family: 'montserrat-bold'; color: black; font-size: 22px;">
          Total ingresos: {{ "$" + formatMoney(sumIncomes) + " " + selectedCurrency }} 
        </v-card-subtitle>
      </v-card>
      <v-card elevation="0"> 
        <v-card-title style="font-family: 'montserrat-bold';">
          Conversiones
          <v-col class="d-flex justify-end pa-0 my-4" style="align-items: center;">
            <v-btn color="black" elevation="8" class="white--text ml-4" style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none;" @click="dataXLSXConversions()">
              <v-img class="mr-2" src="../../assets/icons/Vector.svg" style="width: 14px;"></v-img>
              {{ "Descargar" }}
            </v-btn>
          </v-col>
        </v-card-title>
        <v-data-table class="d-none d-sm-block mx-4" :items-per-page="5" hide-default-header :items="conversions" style="background-color: white !important">
          <template v-slot:header="{ props }">
            <thead style="background-color: #f9fafd;">
              <tr>
                <th class="header__title left">{{ "Id" }}</th>    
                <th class="header__title center">{{ "Monto" }}</th>                                                                                                                                                                               
                <th class="header__title right">{{ "Fecha" }}</th>
              </tr>
            </thead>
          </template>
          <template v-slot:body="{ items }">
            <tbody style="background: #f9fafd;">
              <tr v-for="item in items" :key="item.id">
                <td class="table__item">{{ item.iTrackingId}}</td>
                <td class="table__item">{{ "$ " + formatMoney(item.dAmount) + " " + selectedCurrency }}</td>
                <td class="table__item">{{ formatDate(item.created_at) }}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
        <v-card-subtitle class="text-right mt-2 mr-4" style="font-family: 'montserrat-bold'; color: black; font-size: 22px;">
          Total conversiones: {{ "$" + formatMoney(sumConversions) + " " + selectedCurrency }} 
        </v-card-subtitle>
      </v-card>
      <v-card elevation="0">
        <v-card-title style="font-family: 'montserrat-bold';">
          Egresos
          <v-col class="d-flex justify-end pa-0 my-4" style="align-items: center;">
            <v-btn color="black" elevation="8" class="white--text ml-4" style="border-radius: 36px; border: 2px solid #000000; font-family: 'montserrat-semibold'; text-transform: none;" @click="dataXLSXPayment()">
              <v-img class="mr-2" src="../../assets/icons/Vector.svg" style="width: 14px;"></v-img>
              {{ "Descargar" }}
            </v-btn>
          </v-col>
        </v-card-title>
        <v-data-table class="d-none d-sm-block mx-4" :items-per-page="5" hide-default-header :items="payments" style="background-color: white !important">
          <template v-slot:header="{ props }">
            <thead style="background-color: #f9fafd;">
              <tr>
                <th class="header__title left">{{ "Id" }}</th>    
                <th class="header__title center">{{ "Monto" }}</th>                                                                                                                                                                               
                <th class="header__title right">{{ "Fecha" }}</th>
              </tr>
            </thead>
          </template>
          <template v-slot:body="{ items }">
            <tbody style="background: #f9fafd;">
              <tr v-for="item in items" :key="item.id">
                <td class="table__item">{{ item.iTrackingId}}</td>
                <td class="table__item">{{ "$ " + formatMoney(item.dPaymentAmount) + " " + (item.sCurrency ? item.sCurrency : "") }}</td>
                <td class="table__item">{{ formatDate(item.created_at) }}</td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
        <v-card-subtitle class="text-right mt-2 mr-4" style="font-family: 'montserrat-bold'; color: black; font-size: 22px;">
          Total egresos: {{ "$" + formatMoney(sumPayments) + " " + selectedCurrency }} 
        </v-card-subtitle>
      </v-card>
    </div>
    <div class="d-flex justify-space-between mt-6 px-6">
      <div class="font-weight-bold text-h6">
        💰 Balance calculado: {{ "$" + formatMoney(totalBalance) + " " + selectedCurrency  }}
      </div>
      <div class="font-weight-bold text-h6" :class="(parseInt(balanceReal) === parseInt(totalBalance)) ? 'green--text' : 'red--text'">
        🧾 Balance real: {{ "$" + formatMoney(balanceReal)  + " " + selectedCurrency }}
      </div>
    </div>
  </v-container>
</template>
<script>
  import moment from "moment";
  import * as XLSX from "xlsx";
  import { saveAs } from "file-saver";
  export default {
    name: "Moveimientos",
    props: {
      activeTab: String,
      enterprise: Object,
      permissionList: Array,
    },
    data() {
      return {
        incomes: [],
        sumIncomes: 0,
        payments: [],
        sumPayments: 0,
        walletUSD: 0,
        walletMXN: 0,
        balanceReal: 0,
        totalBalance: 0,
        conversions: [],
        sumConversions: 0,
        selectedCurrency: "USD",
        currencies: [
          { sName: "USD", sValue: "USD" },
          { sName: "MXN", sValue: "MXN" },
        ],
        loading: false,
      }
    },
    watch: {
      activeTab(val) {
        if (val === 'movimientos') {
          this.getMovements();
        }
      }
    },
    mounted() {
      if (this.activeTab === 'movimientos') {
        this.getMovements();
      }
    },
    methods: {
      async getMovements() {
        this.loading = true;
        this.incomes = [];
        this.sumIncomes = 0;
        this.payments = [];
        this.sumPayments = 0;
        this.conversions = [];
        this.sumConversions = 0;
        this.walletUSD = this.enterprise.balance?.balanceUsd?.balance;
        this.walletMXN = this.enterprise.balance?.balanceMxn?.balance;

        DB.get(`${URI}/api/v1/en/administrator/movements/${this.$route.params.sEnterpriseId}/${this.selectedCurrency}`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        })
        .then((response) => {
          this.incomes = response.data.incomes;
          this.sumIncomes = this.incomes.reduce((acc, income) => {
            return acc + Number(income.dAmount || 0);
          }, 0);
          this.payments = response.data.payments;
          this.sumPayments = this.payments.reduce((acc, payment) => {
            return acc + Number(payment.dPaymentAmount || 0);
          }, 0);
          this.conversions = response.data.conversions;
          this.sumConversions = this.conversions.reduce((acc, conversion) => {
            return acc + Number(conversion.dAmount || 0);
          }, 0);
          
          this.totalBalance = Math.round((this.sumIncomes + this.sumPayments + this.sumConversions) * 100) / 100;
          this.balanceReal = this.selectedCurrency == 'USD' ? this.walletUSD : this.walletMXN;
        })
        .catch((error) => {
          this.mixError(error.response.data.message, error.response.status);
        })
        .finally(() => {
          this.loading = false;
        });
      },
      formatDate: function (date) {
        if (this.selectLanguage === "sp") {
          moment.locale("es");
        } else {
          moment.locale("en");
        }
        let newDate = moment(date);
        let formattedDate = newDate.format("MMMM DD, YYYY HH:mm a");
        return formattedDate;
      },
      formatMoney(value) {
        let multiplied = value * 100;
        let rounded = Math.round(multiplied);
        let formattedNumber = rounded / 100;
        // Si el valor es -0, lo convertimos a 0
        if (Object.is(formattedNumber, -0)) {
          formattedNumber = 0;
        }
        return new Intl.NumberFormat("en-US", {
          style: "decimal",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(formattedNumber);
      },
      dataXLSXIncomes() {
        try {
          const data = this.incomes.map((item) => ({
            "ID de seguimiento": item.iTrackingId || "-",
            "Monto": parseFloat(item.dAmount) || "-",
            "Fecha": this.formatDate(item.created_at) || "-",
          }));

          const worksheet = XLSX.utils.json_to_sheet(data);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Ingresos");

          const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
          const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });

          saveAs(blob, "Ingresos.xlsx");

          this.success = true;
          this.msgSuccess = "Descargando ingresos";
        } catch (error) {
          console.error("Error al generar XLSX de ingresos:", error);
          this.error = true;
          this.codeError = "XLSX_INCOMES_FAILED";
        }
      },
      dataXLSXConversions() {
        try {
          const data = this.conversions.map((item) => ({
            "ID de seguimiento": item.iTrackingId || "-",
            "Monto": parseFloat(item.dAmount) || "-",
            "Fecha": this.formatDate(item.created_at) || "-",
          }));

          const worksheet = XLSX.utils.json_to_sheet(data);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Conversiones");

          const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
          const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });

          saveAs(blob, "Ingresos.xlsx");

          this.success = true;
          this.msgSuccess = "Descargando ingresos";
        } catch (error) {
          console.error("Error al generar XLSX de ingresos:", error);
          this.error = true;
          this.codeError = "XLSX_INCOMES_FAILED";
        }
      },
      dataXLSXPayment() {
        try {
          const data = this.payments.map((item) => ({
            "ID de seguimiento": item.iTrackingId || "-",
            "Monto": parseFloat(item.dPaymentAmount) || "-",
            "Fecha": this.formatDate(item.created_at) || "-",
          }));

          const worksheet = XLSX.utils.json_to_sheet(data);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Payments");

          const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
          const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          });

          saveAs(blob, "Ingresos.xlsx");

          this.success = true;
          this.msgSuccess = "Descargando ingresos";
        } catch (error) {
          console.error("Error al generar XLSX de ingresos:", error);
          this.error = true;
          this.codeError = "XLSX_INCOMES_FAILED";
        }
      }
    }
  }
</script>
<style scoped>
</style>